export default {
  industryTitle: 'Industry category',
  concurrentFair: ' Industry exhibition',
  filters: {
    keyword: 'Keyword',
    selectedCondition: 'Selected condition',
    area: 'Area',
    region: 'Region',
    city: 'City',
    hotCity: 'Hot city',
    domestic: 'Domestic fair',
    domesticExh: 'Domestic fair(Hong Kong, Macao and Taiwan)',
    international: 'International fair',
    all: 'All',
    more: 'More',
    packUp: 'Pack Up',
    dateFormat: 'YYYY-MM'
  },
  scale: 'Scale',
  heatSort: 'Heat sort',
  timeSort: 'Time sort',
  recommendedExhibition: 'Recommended exhibition',
  industryNews: ' fair news',
  time: 'Date',
  latestNews: 'Latest news',
  timeUpdate: 'Waiting update time...',
  openness: 'Under way...',
  distance: 'Days to Open: ',
  day: 'days',
  year: ' year ', // 空格必须保留
  periods: ' periods',
  booth: 'Booth',
  ticket: 'Ticket',
  exhibitor: 'Exhibitor',
  hot: 'HOT',
  recommended: 'TOP PICK',
  winnow: 'SELECT',
  visitorViews: ' Views',
  updating: 'Updating...',
  postponed: 'Postponed',
  cancelled: 'Cancelled',
  notNewTime: 'Time to be determined',
  visitorCount: 'Visitor Count',
  daysToOpen: 'Days to Open: ',
  ongoing: 'Ongoing...',
  nextEditionUpdate: 'Next Edition: TBC...',
  standardBooth: 'Standard Booth',
  bareSpace: 'Bare Space',
  subscribed: 'Subscribed',
  subscribe: 'Subscribe',
  recommendedExhibitions1: 'To meet your needs, we recommend ',
  recommendedExhibitions2: 'information about relevant concurrent exhibitions for your reference.',
  servicePrompt:
    'For exhibition participation/visit inquiries, contact our online customer service.',
  contactCustomerService: 'Contact Customer Service'
}
